import * as Yup from 'yup';
import { TFunction } from 'i18next';
import { yupResolver } from '@hookform/resolvers/yup';

export const loginSchema = (t: TFunction) =>
  Yup.object().shape({
    userId: Yup.string().required(t('learner.312')).email(t('learner.312')),
    password: Yup.string().required(t('learner.107')),
  });

export const loginSchemaValidation = (t: TFunction) => ({ resolver: yupResolver(loginSchema(t)) });
